"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteLineItemNumberField = void 0;
var QuoteLineItemContext_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/QuoteLineItem/QuoteLineItemContext");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var QuoteLineItemNumberField = function (_a) {
    var field = _a.field;
    var actions = (0, QuoteLineItemContext_1.useQuoteLineItemContext)().actions;
    if (field.userEditable) {
        return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", gap: "xxs" },
            react_1.default.createElement(kaleidoscope_1.NumberInput, { autoGrow: true, label: field.label, labelHidden: true, variant: "underlined", size: "s", value: field.value, onChange: function (value) {
                    actions.setNumberFieldValue(field.id, value);
                }, min: field.min, max: field.max, step: field.step }),
            field.unit && react_1.default.createElement(kaleidoscope_1.Text, null, field.unit)));
    }
    var displayValue = field.unit ? "".concat(field.value, " ").concat(field.unit) : field.value.toString();
    return react_1.default.createElement("div", null, displayValue);
};
exports.QuoteLineItemNumberField = QuoteLineItemNumberField;
